<template>
  <div class="md:flex md:gap-4 md:between divide-grey-70 <md:divide-y" :class="brandClasses">
    <base-collapse
      v-for="({ title, children }, key) in columns"
      :key
      class="w-full md:py-8"
      class-content="md:max-h-screen children:md:!visible"
      class-toggle="w-full md:hidden"
      @expand="$gtm.push('footer.onClickMobileFooterColumn', `Column ${key + 1}`)"
    >
      <template #toggle="{ expanded }">
        <span class="flex items-center between <md:p-4 subtitle-4 ">
          {{ title }}
          <vf-icon class="md:hidden" :dir="expanded ? 'up' : 'down'" name="chevron" size="lg" />
        </span>
      </template>

      <h2 class="<md:hidden subtitle-4 ">
        {{ title }}
      </h2>

      <div class="<md:px-4 <md:pb-4">
        <ul class="text-sm md:mt-4 space-y-4 ">
          <li v-for="(child, j) in children" :key="j" class="space-y-4">
            <lazy-cms-section
              :key="child.id"
              :section="{ name: child.id, items: [{ ...child, footerItemL1: `Column ${key + 1}` }] }"
            />
          </li>
        </ul>
      </div>

      <ul v-if="appStoreLinks && key === appStoreKey" class="md:mt-4 space-y-4 <md:px-4 <md:pb-4">
        <li v-for="({ icon, link, alt }, index) in appStoreLinks" :key="index" class="space-y-4">
          <base-link :to="link">
            <base-picture
              :alt
              height="36"
              :props-img="{ class: 'w-full' }"
              :src="icon"
              style="height: 2.25rem"
              width="108"
            />
          </base-link>
        </li>
      </ul>
    </base-collapse>
  </div>
</template>

<script lang="ts" setup>
import type { GetFooterData } from '#root/api/clients/internal/data-contracts'

const props = defineProps<{
  footerData: GetFooterData | null
}>()

const { brandClasses } = useAppConfig().components.vf.footer.columns

const { getFooter } = useCms()

const cmsFooter = await getFooter()

const columns = computed(() => cmsFooter?.columns || [])

const { storeIcons } = cmsFooter || {}
const appStoreLinks = storeIcons?.storeColumn
  ? props.footerData?.links?.appStores?.filter(({ name }) => storeIcons[name])
  : []
const appStoreKey = storeIcons?.storeColumn ? Number.parseInt(storeIcons.storeColumn) - 1 : 0
</script>
